export let productCentermeidushaViewEN = {
  title: {
    h1: "Medusa Whole-Vehicle High-Validity \nSimulation Platform",
    h2: "Parallel Computing for Maximized Efficiency",
    h3: "Medusa",
    h4: "As an X-in-the-loop simulation platform for AI-powered spatial agents, it enables concurrent testing of perception-fusion and planning & control algorithms based on all on-board sensors, significantly enhancing testing efficiency and accelerating algorithm iteration.",
  },
  introImg: require("@/static/img/meiDuShaComputer_en.webp"),
  meiDuShaModule3: {
    h1: "Product Features",
    meiDuShaModule3Arr: [
      {
        h1: "Ultra-high Computing Power",
        h2: "Delivers outstanding computational performance with native support for parallel computing to accelerate simulation",
      },
      {
        h1: "Multiple Sensor Injection",
        h2: "Support simulation and injection of raw data from multiple active sensors, such as cameras, LiDAR, radar, and support simulation and injection of raw data from multiple 4K or higher definition cameras",
      },
      {
        h1: "Dynamic Modules",
        h2: "Modular design and compact structure, enabling flexible expansion or replacement of modules according to user needs",
      },
      {
        h1: "High-fidelity& Low Latency",
        h2: "High-validity simulation data & low-latency data transmission",
      },
      {
        h1: "Support various communication interfaces",
        h2: "FPD Link, GMSL, Ethernet, CAN, LIN etc",
      },
    ],
  },
};
export let productCentermeidushaViewCN = {
  title: {
    h1: "Medusa（美杜莎） 高置信度仿真平台",
    h2: "并行运算，提高效率",
    h3: "Medusa",
    h4: "是一款用于多种智能体在环仿真测试的平台，可以同时测试所有传感器的感知融合算法以及规控算法，可提高测试效率以加快算法迭代。",
  },
  introImg: require("@/static/img/meiDuShaComputer.png"),
  meiDuShaModule3: {
    h1: "Medusa的特点",
    meiDuShaModule3Arr: [
      {
        h1: "超高算力",
        h2: "算力突出，可同时集成8-48块高性能GPU并行运算，一次性模拟24-144个传感器的输入和输出",
      },
      {
        h1: "多种传感器注入",
        h2: "支持多种传感器原始数据的仿真和注入，如摄像头、激光雷达、雷达等，支持多个4K或更高清摄像头原始数据的仿真和注入",
      },
      {
        h1: "动态模组",
        h2: "模块化设计，结构紧凑，可根据用户需求灵活拓展或更换模组，最多一共可配置6个GPU集群组",
      },
      {
        h1: "高保真低延时",
        h2: "高保真的仿真数据，低延时的数据传输",
      },
      {
        h1: "支持拓展各种通讯接口",
        h2: "如FPD-Link，GMSL，以太网，CAN，LIN等",
      },
    ],
  },
};
